module.exports = __webpack_public_path__ + "media/images/embed-banner-04e11d1a8a8b5d3e3f3177c0be4778fd.png";